import objectPath from "object-path";
import merge from "deepmerge";
import layoutConfig from "@/core/config/DefaultLayoutConfig";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { StoreInfo } from "@/store/theme/interfaces/ConfigInterface";

@Module({
  name: "theme/ConfigModule",
  namespaced: true,
  dynamic: true,
  // preserveState: true,
  stateFactory: true,
  store: store,
})
export default class ConfigModule extends VuexModule implements StoreInfo {
  config = layoutConfig;
  initial = layoutConfig;

  /**
   * Get config from layout config
   * @returns {function(path, defaultValue): *}
   */
  get layoutConfig() {
    return (path, defaultValue: any = "") => {
      return objectPath.get(this.config, path, defaultValue);
    };
  }

  @Mutation
  setLayoutConfig(payload): void {
    this.config = payload;
  }

  @Mutation
  resetLayoutConfig(): void {
    this.config = Object.assign({}, this.initial);
  }

  @Mutation
  overrideLayoutConfig(): void {
    this.config = this.initial = Object.assign(
      {},
      this.initial,
      JSON.parse(window.localStorage.getItem("config") || "{}")
    );
  }

  @Mutation
  overridePageLayoutConfig(payload): void {
    this.config = merge(this.config, payload);
  }
}
